import { render, staticRenderFns } from "./OrdersEdition.vue?vue&type=template&id=aafee3b4&scoped=true&"
import script from "./OrdersEdition.vue?vue&type=script&lang=js&"
export * from "./OrdersEdition.vue?vue&type=script&lang=js&"
import style0 from "./OrdersEdition.vue?vue&type=style&index=0&id=aafee3b4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aafee3b4",
  null
  
)

export default component.exports